import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

// Multi-select de tipos de evento (FRA-287, admin-only). value = array de ids
// de eventTypes en venues/{id}.eventTypes. Decide en qué landings de evento
// aparece el venue — reemplaza la heurística por estilos (event.styles).
export default function EventTypeTagsField({ value = [], onChange }) {
  const [eventTypes, setEventTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDocs(collection(db, "eventTypes"))
      .then((snap) => {
        const docs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        docs.sort((a, b) => (a.orden || 0) - (b.orden || 0));
        setEventTypes(docs);
      })
      .catch((e) => console.error("Error loading eventTypes:", e))
      .finally(() => setLoading(false));
  }, []);

  const toggle = (id) => {
    onChange(
      value.includes(id) ? value.filter((v) => v !== id) : [...value, id]
    );
  };

  if (loading) return <p className="text-sm text-gray-500">Cargando...</p>;

  if (eventTypes.length === 0) {
    return (
      <p className="text-sm text-gray-500">
        No hay tipos de evento definidos aún — créalos en Tipos de Evento.
      </p>
    );
  }

  return (
    <div>
      <p className="text-sm text-gray-600 mb-3">
        El venue aparecerá en las landings de los tipos seleccionados (p. ej.
        /bodas, /bodas/cdmx).
      </p>
      <div className="flex flex-wrap gap-2">
        {eventTypes.map((et) => {
          const selected = value.includes(et.id);
          return (
            <button
              key={et.id}
              type="button"
              onClick={() => toggle(et.id)}
              className={`px-3 py-1.5 rounded-full text-sm border transition-colors ${
                selected
                  ? "text-white border-transparent"
                  : "bg-white text-gray-600 border-gray-300 hover:border-[#1b4d2e] hover:text-[#1b4d2e]"
              }`}
              style={selected ? { backgroundColor: "#1b4d2e" } : undefined}
            >
              {et.label?.ES || et.id}
              {!et.activo && " (inactivo)"}
            </button>
          );
        })}
      </div>
    </div>
  );
}
